import { ReportChartGroupCompareItemType } from '@vision/ui/interfaces';
import { useEffect, useState } from 'react';
import { ReportsDetailGraphicCompareQuestionScore } from '../../../ReportsDetailGraphicCompareComponents';

interface CompareRendererConfig {
  component: React.FC<{
    compareItemType?: ReportChartGroupCompareItemType;
    required: boolean;
  }>;
  required: boolean;
}

const compareComponentMapping: Partial<Record<ReportChartGroupCompareItemType, CompareRendererConfig>> = {
  'question-option-score': {
    component: ReportsDetailGraphicCompareQuestionScore,
    required: true,
  },
};

interface StarChart1CompareRendererProps {
  compareItemTypes: ReportChartGroupCompareItemType[];
}

export function StarChart1CompareRenderer({ compareItemTypes }: StarChart1CompareRendererProps) {
  const [components, setComponents] = useState<React.JSX.Element[]>([]);

  useEffect(() => {
    const newComponents: React.JSX.Element[] = compareItemTypes.map((compareItemType) => {
      const config = compareComponentMapping[compareItemType];

      if (!config) {
        return null;
      }

      const Component = config.component;

      return <Component key={compareItemType} compareItemType={compareItemType} required={config.required} />;
    });

    setComponents(newComponents);
  }, [compareItemTypes]);

  return <>{components}</>;
}
